<app-expandable-table [info]="tableData" (loadData)="getTickets()" (toggleExpansion)="toggleState($event)"></app-expandable-table>